/* Layout */
import Layout from '@/layout'

/* Router Modules */
const collocationRouter = {
  path: '/collocation',
  component: Layout,
  name: 'collocation',
  redirect: '/collocation',
  meta: {
    title: '搭配应用'
  },
  children: [
    {
      path: '/collocation',
      component: () => import('@/views/collocation/index'),
      name: 'collocation',
      meta: { title: '搭配应用', affix: true, projectId: 5 }
    },
    {
      path: '/collocation/files',
      component: () => import('@/views/collocation/files'),
      name: 'collocationFiles',
      hidden: true,
      meta: { title: '文件详情', affix: true, projectId: 5, guidePath: true, jumpPath: '/collocation' }
    },
    {
      path: '/collocation/detail',
      component: () => import('@/views/collocation/detail'),
      name: 'collocationDetail',
      hidden: true,
      meta: { title: '方案详情', affix: true, projectId: 5, guidePath: true, jumpPath: '/collocation' }
    }
  ]
}

export default collocationRouter
